export const HERO = '/';
export const PORTFOLIO = '/portfolio';
export const SERVICES = '/services';
export const TESTIMONIALS = '/testimoials';
export const CONTACT = '/contact';
export const ABOUT = '/about';
export const RESUME = '/resume';
export const NOT_FOUND = '/404';
